import React from 'react';
import { Typography } from '@mui/material';

/**
 * Tooltips de ayuda de la feature. Siguiendo el patrón del proyecto, cada
 * sección explica en criollo qué es y para qué sirve — el usuario no tiene por
 * qué saber cómo está modelado esto por dentro.
 */

export const condicionCreditoTooltip = (
	<>
		<Typography variant="body2" fontWeight={600} gutterBottom>
			¿Qué es la condición de crédito? 🧾
		</Typography>
		<Typography variant="body2" gutterBottom>
			Es el acuerdo de pago que tenemos con el cliente: <strong>cuándo le facturamos</strong> y{' '}
			<strong>cuándo vence esa factura</strong>.
		</Typography>
		<Typography variant="body2" gutterBottom>
			Cuando el cliente tiene una condición cargada, el sistema completa solo la fecha de vencimiento al facturar. Se
			terminó el excel y el &laquo;¿a cuántos días era este?&raquo;.
		</Typography>
		<Typography variant="body2">
			La condición sale del contrato firmado con el cliente, así que solo la puede cambiar un administrador.
		</Typography>
	</>
);

export const dosEjesTooltip = (
	<>
		<Typography variant="body2" fontWeight={600} gutterBottom>
			Los dos ejes de una condición ⚙️
		</Typography>
		<Typography variant="body2" component="ul" sx={{ pl: 2, m: 0 }}>
			<li>
				<strong>Corte</strong> — cuándo se juntan los servicios en una factura. Puede ser sin corte (se factura al
				emitir cada servicio), semanal, quincenal o mensual.
			</li>
			<li>
				<strong>Vencimiento</strong> — cuándo vence esa factura: a X días, el último día del mes, un día puntual del
				mes, o un día de semana concreto.
			</li>
		</Typography>
		<Typography variant="body2" mt={1}>
			Por ejemplo: <em>corte quincenal + 10 días después del corte</em> significa que lo emitido del 1 al 15 se factura
			con vencimiento el 25, y lo del 16 a fin de mes vence el 10 del mes siguiente.
		</Typography>
	</>
);

export const vencimientoAutomaticoTooltip = (
	<>
		<Typography variant="body2" fontWeight={600} gutterBottom>
			¿Por qué se completó solo? 🤖
		</Typography>
		<Typography variant="body2" gutterBottom>
			El cliente tiene una condición de crédito cargada, y el sistema calculó el vencimiento a partir de ella y de la
			fecha de emisión de esta factura.
		</Typography>
		<Typography variant="body2">
			Podés cambiar la fecha a mano si este caso es una excepción — pero si el cliente cambió sus condiciones, lo
			correcto es actualizar la condición en su ficha para que aplique a todas sus facturas.
		</Typography>
	</>
);

export const catalogoTooltip = (
	<>
		<Typography variant="body2" fontWeight={600} gutterBottom>
			¿Qué es el catálogo de condiciones? 📚
		</Typography>
		<Typography variant="body2" gutterBottom>
			Las condiciones se definen una vez y se asignan a muchos clientes. Casi todos los clientes de Uruguay son
			&laquo;30 días&raquo; y casi todos los de Paraguay &laquo;15 días&raquo;.
		</Typography>
		<Typography variant="body2">
			La ventaja: si mañana cambia una condición, la editás en un solo lugar y aplica a todos los clientes que la tengan
			asignada.
		</Typography>
	</>
);

export const vigenciaTooltip = (
	<>
		<Typography variant="body2" fontWeight={600} gutterBottom>
			¿Por qué queda historial? 🕐
		</Typography>
		<Typography variant="body2" gutterBottom>
			Cuando le cambiás la condición a un cliente, la anterior no se borra: queda con su fecha de fin.
		</Typography>
		<Typography variant="body2">
			Así, una factura de hace seis meses se sigue explicando con la condición que regía en ese momento, aunque hoy el
			cliente tenga otra. Si el cliente reclama un vencimiento, podés mostrarle exactamente qué se le aplicó y por qué.
		</Typography>
	</>
);
